import { attachUpdateListener, startUpdatePolling } from './sw-update.js';

/**
 * Register the service worker and wire up the update-toast listener + polling.
 *
 * Registers DIRECTLY — it does NOT gate on the window `load` event. The caller
 * (main.js) reaches this only after awaiting locale/units/config/shell
 * bootstrap, by which time `load` has almost always already fired. A
 * `window.addEventListener('load', …)` added at that point never runs, so the
 * SW was never registered (no offline queue, no update toast). Registering
 * directly is correct: first paint has already happened via mountAuthedShell().
 */
export function registerServiceWorker() {
  // Truthiness check, not `in`: some environments (insecure-context
  // fallbacks) expose `navigator.serviceWorker` as a present-but-undefined
  // property, which `in` reports as true. Must match the guard in
  // sw-update.js so the two files agree on what "unsupported" means.
  if (navigator.serviceWorker == null) return;

  (async () => {
    try {
      const reg = await navigator.serviceWorker.register('/sw.js');
      attachUpdateListener(reg);
      startUpdatePolling(reg);
    } catch (err) {
      console.warn('Service worker registration failed:', err);
    }
  })();

  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'NAVIGATE') {
      const url = event.data.url;
      if (typeof url === 'string' && /^#\/[A-Za-z]/.test(url)) {
        window.location.hash = url;
      }
    }
  });
}
